import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  setStep(state, action: PayloadAction<any>) {
    state.currentStep = action.payload;
  },
};
